<div class="municipality-selection" [class.-expanded]="isExpandedStyle">
  <mat-button-toggle-group
    name="navigation"
    *ngIf="showNavigationButton"
    #group="matButtonToggleGroup"
    [class.-hide-search]="!displaySearch"
    class="navigation-container"
    [value]="selectedToggleOption"
  >
    <mat-button-toggle value="municipality" class="navigation-button">
      {{ 'module.shared.municipalitySelection.myCommunitiesMunicipalityNavBtnText' | translate }}</mat-button-toggle
    >
  </mat-button-toggle-group>
  <div>
    <div class="municipality-section">
      <h4 class="municipality-header">
        {{ 'module.shared.municipalitySelection.myCommunitiesMunicipalityHeaderText' | translate }}
      </h4>
      <mat-form-field class="municipality-search-form-field" appearance="{{ searchFieldConfig.appearance }}" [floatLabel]="searchFieldConfig.floatLabel">
        <span matPrefix class="fa fa-map-marker nav-marker"></span>
        <input
          autocomplete="off"
          matInput
          [placeholder]="searchFieldConfig.searchFieldPlaceholder"
          [ngModel]="searchText"
          (keyup)="onMunicipalitySearchChange($event)"
          (focus)="$event.target.select()"
        />
      </mat-form-field>
      <div class="municipality-panel">
        <cdk-virtual-scroll-viewport
          class="virtual-scroll-container"
          [itemSize]="30"
          [maxBufferPx]="200"
          [style.height.px]="virtualScrollHeight"
          [minBufferPx]="100"
        >
          <ng-template #noCheckBox>
            <ng-container *cdkVirtualFor="let municipality of filteredMunicipalities; trackBy: trackByFn; templateCacheSize: 0">
              <div
                class="municipality"
                [ngClass]="{ deactivated: municipality.isDeactivated }"
                [class.-selected]="
                  searchText === municipality ||
                  searchText === municipality.name ||
                  searchText === municipality.name + ' (' + municipality.key + ')' ||
                  municipality.isSelected
                "
                (click)="confirmSelectMunicipality(municipality)"
              >
                <span>{{ municipality.displayName }}</span>
              </div>
            </ng-container>
          </ng-template>
          <div *ngIf="showCheckBox; else noCheckBox">
            <mat-checkbox
              *cdkVirtualFor="let municipality of filteredMunicipalities; trackBy: trackByFn; templateCacheSize: 0"
              [value]="municipality"
              [ngClass]="{ deactivated: municipality.isDeactivated }"
              [class.-selected]="searchText === municipality || searchText === municipality.name"
              (change)="confirmSelectMunicipality(municipality)"
              [checked]="municipality.isSelected"
              >{{ municipality.displayName }}</mat-checkbox
            >
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
</div>
